import { addHours, format, set } from 'date-fns';
import { TIME_INPUT_FORMAT } from '../../../constants';

const QUICK_TIME_HOURS = [9, 12, 18];

export const DEFAULT_SCHEDULE_OFFSET_HOURS = 1;

interface QuickTime {
  label: string;
  date: Date;
}

interface BuildQuickTimesArgs {
  selectedDay: Date | null;
  relativeLabel: string;
  minDate?: Date | null;
  maxDate?: Date | null;
}

export const buildQuickTimes = ({
  selectedDay,
  relativeLabel,
  minDate,
  maxDate,
}: BuildQuickTimesArgs): QuickTime[] => {
  if (!selectedDay) {
    return [];
  }

  const fixedTimes = QUICK_TIME_HOURS.map((hours) => {
    const date = set(selectedDay, { hours, minutes: 0, seconds: 0, milliseconds: 0 });
    return { label: format(date, TIME_INPUT_FORMAT), date };
  });

  const relativeTime = {
    label: relativeLabel,
    date: addHours(new Date(), DEFAULT_SCHEDULE_OFFSET_HOURS),
  };

  return [...fixedTimes, relativeTime].filter(({ date }) => {
    if (date.getTime() < Date.now()) {
      return false;
    }

    if (minDate && date.getTime() <= minDate.getTime()) {
      return false;
    }

    return !maxDate || date.getTime() < maxDate.getTime();
  });
};
